<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <!-- 首页菜单项添加active状态 -->
          <li>
            <router-link
              to="/"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li><a href="#about">关于我们</a></li>
          <li><a href="#service">服务</a></li>
<!--          <li>-->
<!--            <router-link-->
<!--              to="/product"-->
<!--              :class="{ active: $route.name === 'product' }"-->
<!--            >-->
<!--              产品-->
<!--            </router-link>-->
<!--          </li>-->
          <li><a href="#contact">联系我们</a></li>
          <li><a href="#claim">理赔报案</a></li>
          <!-- 登录/个人中心切换 -->
<!--          <li v-if="!isLoggedIn">-->
<!--            <a href="#" @click.prevent="showLoginModal=true">登录</a>-->
<!--          </li>-->
<!--          <li v-else>-->
<!--            <router-link to="/personal">个人中心</router-link>-->
<!--          </li>-->
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li>
            <router-link
              to="/"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li><a href="#about" @click="showMobileMenu=false">关于我们</a></li>
          <li><a href="#service" @click="showMobileMenu=false">服务</a></li>
          <li>
            <router-link
              to="/product"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
          <li><a href="#contact" @click="showMobileMenu=false">联系我们</a></li>
          <li><a href="#claim" @click="showMobileMenu=false">理赔报案</a></li>
          <!-- 登录/个人中心切换 -->
<!--          <li v-if="!isLoggedIn">-->
<!--            <a href="#" @click.prevent="showLoginModal=true;showMobileMenu=false">登录</a>-->
<!--          </li>-->
<!--          <li v-else>-->
<!--            <router-link to="/personal" @click="showMobileMenu=false">个人中心</router-link>-->
<!--          </li>-->
        </ul>
      </div>
    </nav>

    <!-- 登录模态框 -->
    <div class="login-modal" v-show="showLoginModal">
      <div class="modal-content">
        <h3>短信验证码登录</h3>
        <button class="close-btn" @click="showLoginModal=false">×</button>
        <div class="form-group">
          <label>手机号：</label>
          <input type="tel" v-model="mobile" placeholder="请输入11位手机号">
        </div>
        <div class="form-group code-group">
          <label>验证码：</label>
          <div class="code-container">
            <input type="text" v-model="code" placeholder="请输入验证码">
            <button
              class="get-code-btn"
              @click="getVerificationCode"
              :disabled="countdown > 0"
            >
              {{ countdown > 0 ? `${countdown}s后重试` : '获取验证码' }}
            </button>
          </div>
        </div>
        <button class="login-btn" @click="handleLogin">登录</button>
      </div>
    </div>

    <!-- 英雄区 -->
    <!-- 英雄区（添加背景图） -->
    <section class="hero" style="background-image: url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80')">
      <div class="container">
        <h1>专业保险服务 守护您的每一步</h1>
        <p>20年行业经验，为您提供定制化风险解决方案</p>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="section">
      <div class="container">
        <h2>关于我们</h2>
        <p>广东广福宏宇保险经纪有限公司成立于2003年，是经银保监会批准设立的全国性保险经纪机构...</p>
      </div>
    </section>

    <!-- 服务 -->
    <!-- 服务区块（添加服务图标） -->
    <section class="section service-section">
      <div class="container">
        <h2>核心服务</h2>
        <div class="service-grid">
          <div class="service-card">
            <img src="https://cdn-icons-png.flaticon.com/512/3003/3003935.png" alt="方案定制" class="service-icon">
            <h3>保险方案定制</h3>
            <p>专业团队为个人/企业设计专属保障方案</p>
          </div>
          <div class="service-card">
            <img src="https://cdn-icons-png.flaticon.com/512/3144/3144453.png" alt="快速理赔" class="service-icon">
            <h3>快速理赔协助</h3>
            <p>全程协助报案、材料准备及进度跟踪</p>
          </div>
          <div class="service-card">
            <img src="https://cdn-icons-png.flaticon.com/512/3062/3062743.png" alt="风险评估" class="service-icon">
            <h3>风险评估咨询</h3>
            <p>企业/家庭风险隐患专业评估与建议</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品展示（使用Vuex数据） -->
    <!-- 产品区块（添加产品图片） -->
    <section class="section product-section">
      <div class="container">
        <h2>热门保险产品</h2>
        <div class="product-grid">
          <div
            v-for="product in productList"
            :key="product.id"
            class="product-card"
          >
            <img :src="product.image" alt=":product.name" class="product-image">
            <h3>{{ product.name }}</h3>
            <p class="price">¥{{ product.price }}/年</p>
            <p class="desc">{{ product.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <!-- 客户评价（添加用户头像） -->
    <section class="section review-section">
      <div class="container">
        <h2>客户评价</h2>
        <div class="review-slider">
          <div class="review-card">
            <img src="https://randomuser.me/api/portraits/men/75.jpg" alt="客户头像" class="review-avatar">
            <p>"服务专业高效，理赔速度超出预期！"</p>
            <span>- 张先生 企业客户</span>
          </div>
          <div class="review-card">
            <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="客户头像" class="review-avatar">
            <p>"家庭保障方案非常全面，顾问讲解清晰易懂。"</p>
            <span>- 李女士 个人客户</span>
          </div>
          <div class="review-card">
            <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="客户头像" class="review-avatar">
            <p>"家庭保障方案非常全面，顾问讲解清晰易懂。"</p>
            <span>- 王女士 个人客户</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="section">
      <div class="container">
        <h2>联系我们</h2>
        <form class="claim-form">
          <input type="text" placeholder="姓名" required>
          <input type="tel" placeholder="联系电话" required>
          <textarea placeholder="描述" rows="5" required></textarea>
          <button type="submit">提交报案</button>
        </form>
      </div>
    </section>

    <!-- 理赔报案 -->
    <!-- 理赔流程 -->
    <section id="claim-process" class="section">
      <div class="container">
        <h2>理赔服务流程</h2>
        <div class="claim-flow">
          <!-- 步骤1 -->
          <div class="flow-step">
            <div class="step-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png" alt="事故发生">
            </div>
            <div class="step-info">
              <h3>Step 1 事故发生</h3>
              <p>请立即确保人身安全，保留事故现场证据（照片/视频/证人信息等）</p>
            </div>
          </div>

          <!-- 步骤2 -->
          <div class="flow-step">
            <div class="step-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/3144/3144453.png" alt="立即报案">
            </div>
            <div class="step-info">
              <h3>Step 2 立即报案</h3>
              <p>通过官网/APP/客服热线（020-12345678）报案，提供保单号及事故基本信息</p>
            </div>
          </div>

          <!-- 步骤3 -->
          <div class="flow-step">
            <div class="step-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/3062/3062743.png" alt="提交材料">
            </div>
            <div class="step-info">
              <h3>Step 3 提交材料</h3>
              <p>根据指引提交：身份证、保单、事故证明、医疗/维修单据等材料</p>
            </div>
          </div>

          <!-- 步骤4 -->
          <div class="flow-step">
            <div class="step-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/3003/3003935.png" alt="审核处理">
            </div>
            <div class="step-info">
              <h3>Step 4 审核处理</h3>
              <p>专业理赔团队72小时内完成材料审核，特殊情况将主动联系说明</p>
            </div>
          </div>

          <!-- 步骤5 -->
          <div class="flow-step">
            <div class="step-icon">
              <img src="https://cdn-icons-png.flaticon.com/512/263/263142.png" alt="赔付到账">
            </div>
            <div class="step-info">
              <h3>Step 5 赔付到账</h3>
              <p>审核通过后，3个工作日内赔付至指定银行账户（支持实时到账查询）</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2025 广东广福宏宇保险经纪有限公司 粤ICP备2025485413号-1 服务及投诉电话：400-867-5672</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { shopService } from '@/utils/axios' // 引入短信接口专用实例

export default {
  name: 'index',
  data () {
    return {
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showLoginModal: false, // 登录模态框显示状态
      username: '', // 登录用户名
      password: '', // 登录密码
      showBackToTop: false, // 返回顶部按钮显示状态
      mobile: '', // 新增：手机号
      code: '', // 新增：验证码
      countdown: 0, // 新增：验证码倒计时
      isLoggedIn: false, // 获取登录状态
      userInfo: {} // 获取用户信息（含 token）
    }
  },
  computed: {
    ...mapState({
      // 为产品数据添加图片字段（需要同步修改store）
      productList: state => state.productList.map(p => ({
        ...p,
        image: [
          'https://picsum.photos/id/119/600/400', // 示例图1
          'https://picsum.photos/id/26/600/400', // 示例图2
          'https://picsum.photos/id/328/600/400' // 示例图3
        ][p.id - 1]
      }))
    })
  },
  created () {
    // 组件加载时检查是否已登录
    if (localStorage.getItem('insuranceStore') != null) {
      this.isLoggedIn = true
      this.userInfo = JSON.parse(localStorage.getItem('user'))
      // 调用 Vuex action 检查 token 是否过期
      // this.$store.dispatch('checkToken')
    }
  },
  mounted () {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
    // 加载产品数据
    this.$store.dispatch('fetchProductList')
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 获取短信验证码
    async getVerificationCode () {
      // 手机号格式校验
      if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
        this.$message.warning('请输入有效的11位手机号')
        return
      }

      // 调用短信接口（实际需调用API）
      try {
        // 启动60秒倒计时
        this.countdown = 60
        const timer = setInterval(() => {
          if (this.countdown > 0) this.countdown--
          else clearInterval(timer)
        }, 1000)
        // 调用短信接口（假设接口返回 { success: boolean, message: string }）
        const res = await shopService.post('/website/dxjk', {
          phoneNumber: this.mobile,
          smsmode: '0'
        })

        if (res.data.success) { // 成功
          this.$message.success(res.data.message || '验证码已发送，请注意查收')
        } else { // 失败
          console.log(res)
          this.$message.error(res.data.message || '验证码发送失败，请稍后再试')
        }
      } catch (error) { // 网络错误
        this.$message.error('网络请求失败，请检查网络连接')
      }
    },
    // 登录处理（示例）
    async handleLogin () {
      // 校验输入
      if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
        this.$message.warning('请输入有效的11位手机号')
        return
      }
      if (!this.code) {
        this.$message.warning('请输入验证码')
        return
      }

      try {
        // 调用登录接口，传递 phoneNumber 和 code
        const res = await shopService.post('/website/login', {
          phoneNumber: this.mobile,
          code: this.code
        })

        if (res.data.success) {
          this.$message.success('登录成功！')
          this.showLoginModal = false
          // 更新 Vuex 登录状态（假设 store 有 SET_LOGIN_STATUS mutation）
          this.$store.commit('SET_LOGIN_STATUS', true)
          // 新增：存储用户数据到 Vuex
          this.$store.commit('SET_USER_INFO', res.data.result)
          this.isLoggedIn = true
        } else {
          this.$message.error(res.data.message || '登录失败，请检查手机号或验证码')
        }
      } catch (error) {
        this.$message.error('网络请求失败，请稍后再试')
      }
    }
  }
}
</script>

<style scoped>
/* 新增理赔流程样式 */
.claim-flow {
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 800px;
  margin: 0 auto;
}

.flow-step {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 25px;
  align-items: center;
}

.step-icon {
  width: 80px;
  height: 80px;
  background: #f0f8ff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-icon img {
  width: 40px;
  height: 40px;
}

.step-info h3 {
  color: #2c3e50;
  margin-bottom: 8px;
}

.step-info p {
  color: #666;
  line-height: 1.8;
}

/* 步骤间连接线（可选） */
.flow-step:not(:last-child) .step-info {
  position: relative;
}

.flow-step:not(:last-child) .step-info::after {
  content: '';
  position: absolute;
  bottom: -25px;
  left: 0;
  width: 2px;
  height: 30px;
  background: #3498db;
}
/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 登录模态框 */
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 25px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  position: relative;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.code-container {
  display: flex;
  gap: 10px;
}

.get-code-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 0 15px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.get-code-btn:disabled {
  background: #95a5a6;
  cursor: not-allowed;
}

.login-btn {
  width: 100%;
  background: #3498db;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  font-size: 1rem;
  margin-top: 10px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

/* 英雄区 */
.hero {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80vh;
  background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('https://example.com/hero-bg.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: #fff;
  margin-top: 70px;
}

/* 通用区块 */
.section {
  padding: 80px 0;
}

.section h2 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 2rem;
  color: #2c3e50;
}

.service-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 15px;
}

.product-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 15px;
}

.review-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 10px;
}

/* 服务网格 */
.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.service-card {
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
  text-align: center;
}

/* 产品网格（使用Vuex数据） */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.product-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-card .price {
  color: #e74c3c;
  font-size: 1.2rem;
  margin: 10px 0;
}

/* 客户评价 */
.review-slider {
  display: flex;
  gap: 30px;
  overflow-x: auto;
  padding: 20px 0;
}

.review-card {
  min-width: 300px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

/* 联系我们 */
.contact-info {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  font-size: 1.1rem;
}

/* 理赔报案表单 */
.claim-form {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.claim-form input, .claim-form textarea {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.claim-form button {
  padding: 12px;
  background: #27ae60;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue